module.exports = __webpack_public_path__ + "static/media/testing.7f20ed84.jpeg";